import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
// import { Typography } from '@material-ui/core';

const styles = {
  root: (theme) => ({
    textAlign: 'center',
    padding: theme.spacing(3)
  }),
  image: {
    height: 240,
    backgroundImage: 'url("/images/undraw_empty_xct9.svg")',
    backgroundPositionX: 'right',
    backgroundPositionY: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
  },
  text: (theme) => ({
    marginTop: theme.spacing(3)
  })
};

function Placeholder({ className, ...rest }) {

  return (
    <Box {...rest} className={className} sx={styles.root}>
      <div style={styles.image} />
    </Box>
  );
}

Placeholder.propTypes = {
  className: PropTypes.string
};

export default Placeholder;
